/**
 * Labstep
 *
 * @module components/Layout/Links/State
 * @desc State based sublinks + rendering
 */

import classnames from 'classnames';
import type React from 'react';
import { useState } from 'react';
import styles from '../styles.module.scss';
import type { LayoutLinksStateProps } from './types';

export const LayoutLinksState: React.FC<LayoutLinksStateProps> = ({
  tabs,
  inverted,
  stretch,
}) => {
  const [activeTabKey, setActiveTabKey] = useState(tabs[0].key);
  const activeTab = tabs.find((tab) => activeTabKey === tab.key);
  return (
    <div data-testid="layout-links">
      <div className={styles.linksContainer}>
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={classnames(styles.link, {
              [styles.inverted]: inverted,
              [styles.stretch]: stretch,
              active: activeTabKey === tab.key,
            })}
            onClick={() => setActiveTabKey(tab.key)}
          >
            {tab.key}
          </div>
        ))}
      </div>
      <div>{activeTab ? activeTab.render({}) : null}</div>
    </div>
  );
};
